import React from 'react';
import Icon from './icons';
import VMMetrics from '../../components/VMMetrics';
import VMConsolePanel from './VMConsolePanel';
import VMAgentInfoPanel from './VMAgentInfoPanel';
import VMBootOrderPanel from './VMBootOrderPanel';
import VMLogsPanel from './VMLogsPanel';
import VMBackupsPanel from './VMBackupsPanel';
import VMCDROMPanel from './VMCDROMPanel';
import VMResizeModal from './VMResizeModal';
import VMDiskThrottleModal from './VMDiskThrottleModal';
import VMNetworkClassPanel from './VMNetworkClassPanel';
import VMSolicitacoesPanel from './VMSolicitacoesPanel';

function EmptyState({ title, text, action }) {
  return (
    <div className="vmd-empty">
      <h3>{title}</h3>
      <p>{text}</p>
      {action}
    </div>
  );
}

function VMSectionView({
  section, vmid, vm, isAdmin, goTo,
  consoleProps, consoleOpen, consoleLoading, onOpenConsole, onSendCtrlAltDel, pasteOpen, onTogglePaste,
  agentInfo, agentNetworks,
  bootProps, cdrom, cdromProps, backupsProps, logsProps, resizeProps, throttleProps,
}) {
  const close = () => goTo('overview');

  switch (section) {
    case 'overview':
      return <VMMetrics vmid={vmid} />;

    case 'console':
      if (vm?.status !== 'running') {
        return <EmptyState title="VM desligada" text="Inicie a VM para abrir o console." />;
      }
      return (
        <section className="vmd-section">
          <div className="vmd-section-head">
            <h2>Console</h2>
            <div className="vmd-toolbar">
              {!consoleOpen && (
                <button type="button" className="vmd-btn primary" onClick={onOpenConsole} disabled={consoleLoading}>
                  <Icon name="monitor" size={14} /> {consoleLoading ? 'Conectando…' : 'Conectar'}
                </button>
              )}
              <button type="button" className="vmd-btn ghost" onClick={onSendCtrlAltDel} disabled={!consoleOpen}>Ctrl+Alt+Del</button>
              <button type="button" className={`vmd-btn ghost${pasteOpen ? ' active' : ''}`} onClick={onTogglePaste} disabled={!consoleOpen}>
                <Icon name="clipboard" size={14} /> Colar
              </button>
              <a className="vmd-btn ghost" href={`/vm/${vmid}/console/full`} target="_blank" rel="noopener noreferrer">
                <Icon name="maximize" size={14} /> Tela cheia
              </a>
              <button type="button" className="vmd-btn ghost" onClick={close}>
                <Icon name="x" size={14} /> Fechar
              </button>
            </div>
          </div>
          <VMConsolePanel {...consoleProps} />
        </section>
      );

    case 'cpu-ram':
      if (!isAdmin) return null;
      return <VMResizeModal inline {...resizeProps} onClose={close} />;

    case 'boot':
      return <VMBootOrderPanel {...bootProps} onClose={close} />;

    case 'cdrom':
      if (!cdrom) return <EmptyState title="Sem unidade de CD/DVD" text="Esta VM não tem drive de CD/DVD configurado." />;
      return <VMCDROMPanel cdrom={cdrom} {...cdromProps} onClose={close} />;

    case 'disk-io':
      if (!isAdmin) return null;
      return <VMDiskThrottleModal inline {...throttleProps} onClose={close} />;

    case 'interfaces': {
      const hasAgent = (agentInfo?.filesystems?.length > 0) || (agentNetworks?.agentRunning && agentNetworks.interfaces?.length > 0);
      if (!hasAgent) {
        return <EmptyState title="QEMU Guest Agent inativo" text="Instale e habilite o qemu-guest-agent na VM para ver partições e interfaces de rede." />;
      }
      return <VMAgentInfoPanel agentInfo={agentInfo} agentNetworks={agentNetworks} />;
    }

    case 'conexoes':
      if (!isAdmin) return null;
      return <VMNetworkClassPanel vmid={vmid} onClose={close} />;

    case 'backups':
      return <VMBackupsPanel {...backupsProps} onClose={close} />;

    case 'logs':
      return <VMLogsPanel {...logsProps} onClose={close} />;

    case 'solicitacoes':
      return <VMSolicitacoesPanel vmid={vmid} onClose={close} />;

    default:
      return null;
  }
}

export default VMSectionView;
